export default [
  [
    {
      element: 'Cl',
      charge: 2,
    },
    [3, 5],
  ],
  [
    {
      element: 'Ga',
      charge: 0,
    },
    [3],
  ],
  [
    {
      element: 'Po',
      charge: 3,
    },
    [3],
  ],
  [
    {
      element: 'Si',
      charge: 2,
    },
    [2],
  ],
  [
    {
      element: 'In',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'Bi',
      charge: -3,
    },
    [0],
  ],
  [
    {
      element: 'As',
      charge: 0,
    },
    [3, 5],
  ],
  [
    {
      element: 'B',
      charge: 1,
    },
    [2],
  ],
  [
    {
      element: 'Sn',
      charge: 0,
    },
    [2, 4],
  ],
  [
    {
      element: 'Ge',
      charge: 3,
    },
    [1],
  ],
  [
    {
      element: 'I',
      charge: 3,
    },
    [2, 4],
  ],
  [
    {
      element: 'Pb',
      charge: -1,
    },
    [3, 5],
  ],
  [
    {
      element: 'At',
      charge: 3,
    },
    [2, 4],
  ],
  [
    {
      element: 'Se',
      charge: 3,
    },
    [3],
  ],
  [
    {
      element: 'Ba',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'N',
      charge: -2,
    },
    [1],
  ],
  [
    {
      element: 'Ca',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'K',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'Ra',
      charge: 1,
    },
    [1],
  ],
  [
    {
      element: 'Sb',
      charge: 1,
    },
    [2, 4],
  ],
  [
    {
      element: 'Si',
      charge: 1,
    },
    [3],
  ],
  [
    {
      element: 'Te',
      charge: -1,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'Fr',
      charge: 0,
    },
    [1],
  ],
  [
    {
      element: 'S',
      charge: 0,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'O',
      charge: -2,
    },
    [0],
  ],
  [
    {
      element: 'Na',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'Ga',
      charge: -1,
    },
    [4],
  ],
  [
    {
      element: 'In',
      charge: 0,
    },
    [3],
  ],
  [
    {
      element: 'B',
      charge: 0,
    },
    [3],
  ],
  [
    {
      element: 'As',
      charge: 1,
    },
    [4],
  ],
  [
    {
      element: 'Sn',
      charge: 1,
    },
    [3],
  ],
  [
    {
      element: 'Tl',
      charge: -1,
    },
    [2, 4],
  ],
  [
    {
      element: 'Pb',
      charge: 0,
    },
    [2, 4],
  ],
  [
    {
      element: 'Se',
      charge: 2,
    },
    [4],
  ],
  [
    {
      element: 'N',
      charge: -1,
    },
    [2],
  ],
  [
    {
      element: 'Ca',
      charge: 0,
    },
    [2],
  ],
  [
    {
      element: 'Br',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Te',
      charge: 0,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Ra',
      charge: 2,
    },
    [0],
  ],
  [
    {
      element: 'Sb',
      charge: 2,
    },
    [3],
  ],
  [
    {
      element: 'Fr',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Si',
      charge: 0,
    },
    [4],
  ],
  [
    {
      element: 'Al',
      charge: 3,
    },
    [0],
  ],
  [
    {
      element: 'Cl',
      charge: 3,
    },
    [4],
  ],
  [
    {
      element: 'S',
      charge: -1,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'Cl',
      charge: 0,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'In',
      charge: -1,
    },
    [2, 4],
  ],
  [
    {
      element: 'Mg',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Ga',
      charge: 2,
    },
    [1],
  ],
  [
    {
      element: 'Sn',
      charge: -2,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'F',
      charge: 0,
    },
    [1],
  ],
  [
    {
      element: 'B',
      charge: -1,
    },
    [4],
  ],
  [
    {
      element: 'C',
      charge: 3,
    },
    [1],
  ],
  [
    {
      element: 'As',
      charge: 2,
    },
    [3],
  ],
  [
    {
      element: 'Tl',
      charge: 0,
    },
    [1, 3],
  ],
  [
    {
      element: 'At',
      charge: 1,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Ba',
      charge: 1,
    },
    [1],
  ],
  [
    {
      element: 'I',
      charge: 1,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'P',
      charge: -1,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'K',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Ra',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Rb',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Se',
      charge: 1,
    },
    [3, 5],
  ],
  [
    {
      element: 'Si',
      charge: -1,
    },
    [3, 5],
  ],
  [
    {
      element: 'Al',
      charge: -2,
    },
    [3, 5],
  ],
  [
    {
      element: 'Br',
      charge: 0,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'S',
      charge: 2,
    },
    [4],
  ],
  [
    {
      element: 'Na',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Bi',
      charge: 3,
    },
    [0],
  ],
  [
    {
      element: 'Sb',
      charge: -1,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Po',
      charge: -2,
    },
    [0],
  ],
  [
    {
      element: 'Cl',
      charge: 1,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'In',
      charge: -2,
    },
    [3, 5],
  ],
  [
    {
      element: 'O',
      charge: 3,
    },
    [3],
  ],
  [
    {
      element: 'Li',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Al',
      charge: -3,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Ga',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'B',
      charge: -2,
    },
    [3, 5],
  ],
  [
    {
      element: 'Sn',
      charge: -1,
    },
    [3, 5],
  ],
  [
    {
      element: 'Cs',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'As',
      charge: 3,
    },
    [0],
  ],
  [
    {
      element: 'F',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Se',
      charge: 0,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Rb',
      charge: 0,
    },
    [1],
  ],
  [
    {
      element: 'Pb',
      charge: -2,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'At',
      charge: 2,
    },
    [3, 5],
  ],
  [
    {
      element: 'P',
      charge: 0,
    },
    [3, 5],
  ],
  [
    {
      element: 'Tl',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'K',
      charge: 0,
    },
    [1],
  ],
  [
    {
      element: 'Ba',
      charge: 0,
    },
    [2],
  ],
  [
    {
      element: 'Ge',
      charge: -2,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'I',
      charge: 2,
    },
    [3, 5],
  ],
  [
    {
      element: 'Ra',
      charge: 0,
    },
    [2],
  ],
  [
    {
      element: 'Si',
      charge: -2,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Br',
      charge: 1,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Te',
      charge: -2,
    },
    [0],
  ],
  [
    {
      element: 'Bi',
      charge: 2,
    },
    [3],
  ],
  [
    {
      element: 'S',
      charge: 1,
    },
    [3, 5],
  ],
  [
    {
      element: 'Na',
      charge: 0,
    },
    [1],
  ],
  [
    {
      element: 'Sb',
      charge: 0,
    },
    [3, 5],
  ],
  [
    {
      element: 'Po',
      charge: -1,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'In',
      charge: -3,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Sr',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Li',
      charge: 0,
    },
    [1],
  ],
  [
    {
      element: 'Mg',
      charge: 1,
    },
    [1],
  ],
  [
    {
      element: 'Cs',
      charge: 0,
    },
    [1],
  ],
  [
    {
      element: 'B',
      charge: -3,
    },
    [2],
  ],
  [
    {
      element: 'Rb',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'Se',
      charge: -1,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'Tl',
      charge: 2,
    },
    [0],
  ],
  [
    {
      element: 'C',
      charge: 0,
    },
    [4],
  ],
  [
    {
      element: 'P',
      charge: 1,
    },
    [4],
  ],
  [
    {
      element: 'Ge',
      charge: -1,
    },
    [3, 5],
  ],
  [
    {
      element: 'I',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'At',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Te',
      charge: 3,
    },
    [3],
  ],
  [
    {
      element: 'Be',
      charge: 1,
    },
    [1],
  ],
  [
    {
      element: 'N',
      charge: 2,
    },
    [3],
  ],
  [
    {
      element: 'Sr',
      charge: 0,
    },
    [2],
  ],
  [
    {
      element: 'O',
      charge: 2,
    },
    [4],
  ],
  [
    {
      element: 'Al',
      charge: 0,
    },
    [3],
  ],
  [
    {
      element: 'Br',
      charge: 2,
    },
    [3, 5],
  ],
  [
    {
      element: 'Bi',
      charge: 1,
    },
    [2, 4],
  ],
  [
    {
      element: 'Sb',
      charge: -3,
    },
    [0],
  ],
  [
    {
      element: 'H',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'Pb',
      charge: 3,
    },
    [1],
  ],
  [
    {
      element: 'Li',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'Cl',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Ga',
      charge: 3,
    },
    [0],
  ],
  [
    {
      element: 'Po',
      charge: 0,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Mg',
      charge: 0,
    },
    [2],
  ],
  [
    {
      element: 'F',
      charge: 1,
    },
    [2],
  ],
  [
    {
      element: 'Cs',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'C',
      charge: 2,
    },
    [2],
  ],
  [
    {
      element: 'P',
      charge: 2,
    },
    [3],
  ],
  [
    {
      element: 'C',
      charge: 1,
    },
    [3],
  ],
  [
    {
      element: 'Se',
      charge: -2,
    },
    [0],
  ],
  [
    {
      element: 'Ba',
      charge: 2,
    },
    [0],
  ],
  [
    {
      element: 'Br',
      charge: 3,
    },
    [4],
  ],
  [
    {
      element: 'Tl',
      charge: 3,
    },
    [0],
  ],
  [
    {
      element: 'Ge',
      charge: 0,
    },
    [4],
  ],
  [
    {
      element: 'I',
      charge: 0,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'At',
      charge: 0,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'Al',
      charge: -1,
    },
    [4],
  ],
  [
    {
      element: 'Bi',
      charge: 0,
    },
    [3, 5],
  ],
  [
    {
      element: 'Be',
      charge: 2,
    },
    [0],
  ],
  [
    {
      element: 'O',
      charge: 1,
    },
    [3, 5],
  ],
  [
    {
      element: 'S',
      charge: 3,
    },
    [3],
  ],
  [
    {
      element: 'Sr',
      charge: 1,
    },
    [1],
  ],
  [
    {
      element: 'Sb',
      charge: -2,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'H',
      charge: 0,
    },
    [1],
  ],
  [
    {
      element: 'Po',
      charge: 1,
    },
    [3, 5],
  ],
  [
    {
      element: 'Be',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'Sn',
      charge: 2,
    },
    [0],
  ],
  [
    {
      element: 'B',
      charge: 3,
    },
    [0],
  ],
  [
    {
      element: 'S',
      charge: -2,
    },
    [0],
  ],
  [
    {
      element: 'Ca',
      charge: 1,
    },
    [1],
  ],
  [
    {
      element: 'Ge',
      charge: 1,
    },
    [3],
  ],
  [
    {
      element: 'C',
      charge: -2,
    },
    [2],
  ],
  [
    {
      element: 'P',
      charge: 3,
    },
    [2],
  ],
  [
    {
      element: 'H',
      charge: -1,
    },
    [0],
  ],
  [
    {
      element: 'N',
      charge: 0,
    },
    [3, 5],
  ],
  [
    {
      element: 'Sr',
      charge: 2,
    },
    [0],
  ],
  [
    {
      element: 'O',
      charge: 0,
    },
    [2],
  ],
  [
    {
      element: 'Te',
      charge: 1,
    },
    [3, 5],
  ],
  [
    {
      element: 'Bi',
      charge: -1,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'Sb',
      charge: 3,
    },
    [0],
  ],
  [
    {
      element: 'Pb',
      charge: 1,
    },
    [3],
  ],
  [
    {
      element: 'Al',
      charge: 2,
    },
    [1],
  ],
  [
    {
      element: 'Si',
      charge: 3,
    },
    [1],
  ],
  [
    {
      element: 'Po',
      charge: 2,
    },
    [2, 4],
  ],
  [
    {
      element: 'Mg',
      charge: 2,
    },
    [0],
  ],
  [
    {
      element: 'Bi',
      charge: -2,
    },
    [1, 3, 5, 7],
  ],
  [
    {
      element: 'Be',
      charge: 0,
    },
    [2],
  ],
  [
    {
      element: 'In',
      charge: 2,
    },
    [1],
  ],
  [
    {
      element: 'As',
      charge: -1,
    },
    [2, 4, 6],
  ],
  [
    {
      element: 'B',
      charge: 2,
    },
    [1],
  ],
  [
    {
      element: 'Sn',
      charge: 3,
    },
    [1],
  ],
  [
    {
      element: 'C',
      charge: -1,
    },
    [3, 5],
  ],
  [
    {
      element: 'Ca',
      charge: 2,
    },
    [0],
  ],
  [
    {
      element: 'Ge',
      charge: 2,
    },
    [0],
  ],
  [
    {
      element: 'Te',
      charge: 2,
    },
    [2, 4],
  ],
  [
    {
      element: 'O',
      charge: -1,
    },
    [1],
  ],
  [
    {
      element: 'In',
      charge: 3,
    },
    [0],
  ],
  [
    {
      element: 'N',
      charge: 1,
    },
    [4],
  ],
  [
    {
      element: 'Al',
      charge: 1,
    },
    [2],
  ],
  [
    {
      element: 'Fr',
      charge: 1,
    },
    [0],
  ],
  [
    {
      element: 'Pb',
      charge: 2,
    },
    [0],
  ],
];
